<template>
    <div id="project__deliverable__component">
        <HeaderControlsProjectDeliverableList :projectDeliverable="true" :myWeek='false' @filterUpdated='filterUpdate' @collapseToggleUpdated='collapseToggleUpdate' />
        <div class="container-fluid listing">
            <DeliverablesInProjectList :filterQuery="filterQuery" :myWeek="false" :expandAll="expandAll" />
        </div>
    </div>
</template>

<script>
import DeliverablesInProjectList from "../components/deliverables/DeliverablesInProjectList";
import HeaderControlsProjectDeliverableList from "../components/common/HeaderControlsProjectDeliverableList";
import { mapGetters } from "vuex";

export default {
	props: ['removedDeliverableId'],
  data() {
    return {
      filterQuery: {
        query: "",
        filterByDate: false,
        filterByDateCreated: false,
        filterByDateCompleted: false,
        dateRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        dateCreatedRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        dateCompletedRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        status: [],
        outlet: [],
        deliverableType: [],
        tag: [],
        department: [],
        coordinator: []
      },
      expandAll: !this.isMobile()
    }
  },
  computed: {
    ...mapGetters(["allCustomFields", 'allUsers']),
    statuses() {
      let statusField = _.find(this.allCustomFields, { field_key: "status" });
      if (typeof statusField != "undefined") {
        let valueSet = [],
          data = JSON.parse(statusField.value_set);
        Object.keys(data).forEach(function(item) {
          valueSet.push(data[item]);
        });
        return valueSet;
      }
    }
  },
  components: {
    DeliverablesInProjectList,
    HeaderControlsProjectDeliverableList
  },
  methods: {
    filterUpdate(filterQuery) {
      this.filterQuery = filterQuery
    },
    collapseToggleUpdate(expandAll) {
      this.expandAll = expandAll
    }
  }
};
</script>

<style>

</style>